import PropTypes from 'prop-types';
import React from 'react';

import Text from '../../../../text/Text.jsx';

const LocationHeader = ({ headline }) => {
  const renderHeadline = () => {
    if (!headline) return null;

    const words = headline.split(' ');
    if (words.length >= 3) {
      const firstPart = words.slice(0, 2).join(' ');
      const secondPart = words.slice(2).join(' ');

      return (
        <h2 className="location__headline">
          <span className="location__headline-first">{firstPart}</span>
          <span className="location__headline-second">{secondPart}</span>
        </h2>
      );
    }

    return (
      <Text className="location__headline" tag="h2" modifiers={['headline-2']}>
        {headline}
      </Text>
    );
  };

  return <div className="location__header">{renderHeadline()}</div>;
};

LocationHeader.propTypes = {
  headline: PropTypes.string
};

LocationHeader.defaultProps = {
  headline: null
};

export default LocationHeader;
